import React, { useMemo } from 'react';
import { useListTagsQuery } from '../../../API/tags/TagApi';
import { useCreateOrderTagMutation, useListOrderTagsQuery } from '../../../API/order/tags/OrderTagApi';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { Form, Formik } from 'formik';
import { SelectFieldTW } from '../../../tailwindComponents/selectTW/SelectFieldTW';
import { TextFieldTW } from '../../../tailwindComponents/textInputTW/TextFieldTW';
import { ButtonTW } from '../../../tailwindComponents/buttonTW/ButtonTW';
import { ICreateOrderTagRequest } from '../../../types/order/tags/ICreateOrderTagRequest';
import { checkForMutationSuccess } from '../../../API/checkForMutationSuccess';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { associateOrderTagScheme } from '../../../validation/order/OrderTagValidators';

export const AssociateTagForm: React.FC<{
  currentOrderId: string;
  setAddTag: React.Dispatch<React.SetStateAction<boolean>>;
  setEditTags: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ currentOrderId, setAddTag, setEditTags }) => {
  const { data: allTags } = useListTagsQuery({ isActive: true });
  const { data: allOrderTags } = useListOrderTagsQuery(currentOrderId);
  const [createAssociation, { error, isLoading }] = useCreateOrderTagMutation();

  const tagOptions: SelectOption[] = useMemo(() => {
    const orderTagSet = new Set((allOrderTags ?? []).map((orderTag) => orderTag.tag.id));
    const availableTags = (allTags ?? []).filter((tag) => !orderTagSet.has(tag.id));
    return availableTags.map((tag) => ({ label: tag.label, value: tag.id }));
  }, [allTags, allOrderTags]);

  const onSubmit = async (values: ICreateOrderTagRequest) => {
    const result = await createAssociation(values);
    if (checkForMutationSuccess(result, 'Order Tag Created', 'Error Creating Order Tag')) {
      setAddTag(false);
      setEditTags(false);
    }
  };

  return (
    <>
      <ErrorMessageTW rtkError={error} />
      <Formik
        initialValues={{ orderId: currentOrderId, tagId: '', value: '' }}
        onSubmit={onSubmit}
        validationSchema={associateOrderTagScheme}
        initialTouched={{ value: true }}
      >
        {({ isValid, dirty }) => (
          <Form>
            <SelectFieldTW name={'tagId'} options={tagOptions} labelText={'Tag'} isRequired />
            <TextFieldTW name={'value'} labelText={'Value'} />
            <div className={'flex gap-4'}>
              <ButtonTW type={'submit'} disabled={isLoading || !isValid || !dirty}>
                Save
              </ButtonTW>
              <ButtonTW secondary onClick={() => setAddTag(false)}>
                Cancel
              </ButtonTW>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
